import api from 'api/axiosInstance';
import type {
  Connector,
  UpdateConnectorConnectionResponse,
} from 'types/transactions.types';

export type ConnectorPatchParams = {
  name?: string;
  taxTipsShown?: boolean;
  automatch?: { positive_amount?: boolean; negative_amount?: boolean };
  bankId?: string;
  financialInstitutionSlug?: string;
};

export const updateConnectorConnection = (
  connector: Connector,
  params: Record<string, string>,
): Promise<UpdateConnectorConnectionResponse> => {
  return api.put(`/v2/connectors/${connector._id}/start-flow`, params);
};
